import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { INavbarLink } from '@shared/models/interfaces/navbar-link.interface';

export type NavLinkStatusVariant = 'semaforo' | 'has-error';

@Component({
    selector: 'app-nav-link-status-btn',
    templateUrl: './nav-link-status-btn.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavLinkStatusBtnComponent {
    @Input() navbarLink: INavbarLink;
    @Input() variant: NavLinkStatusVariant = 'semaforo';
    @Input() activeLinkClass = 'disabled';
    @Input() forceDisabled = false;
    @Input() gateErrorByActiveLink = false;
    /** When true, the button shows the neutral loading state instead of its valid/error color. */
    @Input() loading = false;
}
